export default __webpack_public_path__ + "static/media/Ideate_2.07a79aa9.jpg";